import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Grid,
  InputAdornment,
} from '@mui/material';
import { FastOutgoingMessagesDto } from '../../../types/approval.types';
import { formatMoney, paymentPurpose } from '../../../utils/approvalUtils';

interface FastTransactionDetailProps {
  data: FastOutgoingMessagesDto;
}

const FastTransactionDetail: React.FC<FastTransactionDetailProps> = ({ data }) => {
  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="IBAN"
            value={data.ReceiverIBAN || ''}
            disabled
            variant="outlined"
            size="small"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="TCKN"
            value={data.ReceiverIdNo || ''}
            disabled
            variant="outlined"
            size="small"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Alıcı Ad Soyad"
            value={data.ReceiverNameSurname || ''}
            disabled
            variant="outlined"
            size="small"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Ödeme Nedeni"
            value={paymentPurpose(data.PaymentPurpose || '')}
            disabled
            variant="outlined"
            size="small"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Tutar"
            value={formatMoney(data.Value)}
            disabled
            variant="outlined"
            size="small"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Komisyon"
            value={formatMoney(data.ValueFee)}
            disabled
            variant="outlined"
            size="small"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Toplam"
            value={formatMoney(data.Value + data.ValueFee)}
            disabled
            variant="outlined"
            size="small"
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Açıklama"
            value={data.Description}
            disabled
            variant="outlined"
            size="small"
            multiline
            rows={3}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FastTransactionDetail;
